const CepClear = (number?: string) => {
  if (!number) return number;
  return number.replace("-", "").replace(".", "").replace(/,/g, ".");
};

export default CepClear;
